// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"paymentRequests_dashboardContainer__zedPF","MuiGrid-item":"paymentRequests_MuiGrid-item__tjpd2","MuiPaper-root":"paymentRequests_MuiPaper-root__CB+4g"};